import { SET_ITEMS, ADD_ITEM, SET_ERROR } from '../mutation-types'

import axios from 'axios'
import isFuture from 'date-fns/is_future'
import _get from 'lodash/get'
import findIndex from 'lodash/findIndex'

const DELETE_ITEM = 'DELETE_ITEM'

export default {
    namespaced: true,

    state: {
        data: [],
        error: null
    },

    getters: {
        unexpiredCount: state => {
            return state.data.filter(challenge => isFuture(challenge.expire_at)).length
        },

        error: state => field => {
            return state.error && state.error.errors ? _get(state.error.errors, field) : null
        }
    },

    mutations: {
        [SET_ITEMS](state, data) {
            state.data = data
        },

        [ADD_ITEM](state, row) {
            state.data.unshift(row)
        },

        [SET_ERROR](state, error = null) {
            state.error = error
        },

        [DELETE_ITEM](state, challengeId) {
            const index = findIndex(state.data, challenge => challenge.id === challengeId)
            state.data.splice(index, 1)
        }
    },

    actions: {
        async fetchAll({ commit }) {
            try {
                const response = await axios.get('api/modems/challenges')
                commit(SET_ITEMS, response.data)
            } catch (error) {
                return false
            }

            return true
        },

        async store({ commit }, data) {
            commit(SET_ERROR)

            try {
                const response = await axios.post('api/modems/challenges', data)
                commit(ADD_ITEM, response.data)
            } catch (error) {
                if (error.response.status === 422) {
                    commit(SET_ERROR, error.response.data || {})
                }

                return false
            }

            return true
        },

        async delete({ commit }, challengeId) {
            try {
                await axios.delete(`api/modems/challenges/${challengeId}`)

                commit(DELETE_ITEM, challengeId)
            } catch (error) {
                return false
            }

            return true
        }
    }
}
